import { gql } from "lib/apolloClient";

export const plannerElementSetFragment = gql`
  fragment PlannerElementSetBasicDetails on PlannerElementSet {
    id
    type
    label
    config {
      id
      config
      valueType
      value
    }
  }
`;

export const plannerElementSetFieldsBasicDetailsFragment = gql`
  fragment PlannerElementSetFieldsBasicDetails on PlannerElementSet {
    label
  }
`;

export const plannerElementSetFieldsFragment = gql`
  fragment PlannerElementSetFields on PlannerElementSet {
    id
    label
    type
    isConfigured
    isIncludedInInsights
    config {
      id
      config
      valueType
      value
    }
    templateFields(filters: $templateFieldFilters) {
      id
      config(filter: $templateFieldConfigFilters) {
        id
        globalFieldProperty {
          id
          property
        }
        values(filters: $templateFieldPropertyValuesFilters) {
          id
          value
          configLevel {
            id
            type
          }
        }
      }
    }
    templates(filters: $templateFilters) {
      id
      name
      unitType
      isGlobal
      isPublish
      draftTemplate {
        id
      }
    }
  }
`;

export const downloadUrlResponseFragment = gql`
  fragment downloadUrlResponseItem on DownloadUrlResponse {
    url
    isSuccess
  }
`;
